import type { ReactNode } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { SUPPORT_PREFIX } from "@/lib/client";

/** errorText çıktısı: cümle + (varsa) soluk "Destek kodu" satırı (ui.md §10.3). */
export function ErrorLines({ text: all }: { text: string }) {
  const [text, ...rest] = all.split("\n");
  const support = rest.find((l) => l.startsWith(SUPPORT_PREFIX));
  return <><p>{text}</p>{support && <p className="text-xs text-muted-foreground">{support}</p>}</>;
}

export function ErrorAlert({ children }: { children: string | ReactNode }) {
  return <Alert variant="destructive"><AlertDescription>{typeof children === "string" ? <ErrorLines text={children} /> : children}</AlertDescription></Alert>;
}
